
import { useEffect, useState } from "react";
import useProjects from "../../../hooks/useProjects";
import { FilledButton, OutlinedButton } from "../../common/Button";
import Lightbox from "../../common/Lightbox";
import useDisplayNotifications from "../../../hooks/useDisplayNotifications";
import { DisplayNotificationType } from "../../../models/DisplayNotification";
import useMyProjects from "../../../hooks/useMyProjects";
import { IProject } from "../../../data_models/project";
import useCurrentUser from "../../../hooks/useCurrentUser";
import SpeechBubble from "../../aiAgent/SpeechBubble";
import { EmployerWallet } from "../../../data_models/employerWallet";
import useConfig from "../../../hooks/useConfig";
import useRouting from "../../../hooks/useRouting";
import { ITask } from "../../../data_models/task";


interface RequestRoadmapVerificationLightboxProps {
    onClose: () => void;
    projectId: string;
    onUpdateProject: (updatedProject: IProject) => void;
    onUpdateTasks: (updatedTasks: ITask[]) => void;

}

const RequestRoadmapVerificationLightbox: React.FC<RequestRoadmapVerificationLightboxProps> = ({ onClose, projectId, onUpdateProject, onUpdateTasks }) => {

    
    const [loading, setLoading] = useState(false);
    const { fetchWallet, wallet } = useCurrentUser();
    const { config } = useConfig();
    const { triggerRoadmapVerificationByHumanPm } = useProjects();
    const { addSuccessNotification, addErrorNotification } = useDisplayNotifications();
    const { goToPricing } = useRouting();

    const [canPurchase, setCanPurchase] = useState(false);
    const [availableCredits, setAvailableCredits] = useState<number | undefined>(undefined);
    const [requiredCredits, setRequiredCredits] = useState<number | undefined>(undefined);

    useEffect(() => {
        if (wallet) {
            setAvailableCredits((wallet as EmployerWallet).totalCredits - (wallet as EmployerWallet).totalOccupiedCredits);
        }
        if (config) {
            setRequiredCredits(config?.prices?.verifyRoadmapByHumanPm || 0);
        }
    }, [wallet, config]);

    useEffect(() => {
        setCanPurchase((availableCredits || 0) >= (requiredCredits || 0));
    }, [availableCredits, requiredCredits]);



    const onRequestRoadmapVerification = async () => {
        try {
            setLoading(true);
            const result = await triggerRoadmapVerificationByHumanPm(projectId)
            onUpdateProject(result.project);
            result.tasks && onUpdateTasks(result.tasks);
            addSuccessNotification("Successfully requested roadmap verification");
            fetchWallet();
            onClose();
        } catch (error: any) { 
            addErrorNotification(error.message, "Request Failed");
        }
        finally {
            setLoading(false);
        }
    }

    return (
        <Lightbox
            header="Request Expert Review"
            onConfirm={onRequestRoadmapVerification}
            onThirdAction={goToPricing}
            loadingConfirm={loading}
            confirmText={canPurchase ? "Confirm" : "Not Enough Hrs"}
            disabledConfirm={!canPurchase}
            thirdActionText="Buy Credits"
            onCancel={onClose}
            content={
                <div className="flex flex-col items-start space-y-4" >
                    <p>Want an extra layer of confidence? A professional project manager can review your roadmap to make sure everything is realistic and achievable. After confirmation, we’ll assign someone to your project—just give us a little time to get things rolling!</p>
                    <p>Once verified, your PM will fully take charge of your project to ensure it's completed successfully. They'll handle talent assignments, communication, and ensure everything runs smoothly to your satisfaction!</p>
                    <p>You’ll use 10 Hrs for this.</p>
                </div>}
            onClose={onClose}
        />

    );
}

export default RequestRoadmapVerificationLightbox;